import request from "root/js/request";

export const getAnalyticsProductSizes = async ({ cabinet_id, product_id__in, ...rest }) => {
  const response = await request({
    url: `analytics/v3/products_sizes/`,
    method: "get",
    params: {
      cabinet_id,
      product_id__in,
      ...rest,
    },
  });
  return response.data;
};